import TwoImage from "../../ui/questions/TwoImage.svelte";
import ImageTextChoiceTwo from "../../ui/questions/ImageTextChoiceTwo.svelte";
import ImageTextChoiceFour from "../../ui/questions/ImageTextChoiceFour.svelte";
import type { ComponentType, SvelteComponent } from "svelte";

export function resolve( model:any ): ComponentType<SvelteComponent> {
    const componentMap = {
        [ 'App\\Models\\TwoImageQuestion' ]: TwoImage,
        [ 'App\\Models\\ImageTextChoiceTwo' ]: ImageTextChoiceTwo,
        [ 'App\\Models\\ImageTextChoiceFour' ]: ImageTextChoiceFour,
    }
    return componentMap[ model?.modelName ] ?? TwoImage;
}
